import { atom } from 'jotai';

export const communityAtom = atom({
  openIndex: -1,
});
